const Types = {
  // GET CLIENTES
  GET_CLIENTES_REQUEST: '@clientes/GET_CLIENTES_REQUEST',
  GET_CLIENTES_SUCCESS: '@clientes/GET_CLIENTES_SUCCESS',
  GET_CLIENTES_FAILURE: '@clientes/GET_CLIENTES_FAILURE',

  // CREATE CLIENTE
  CREATE_CLIENTE_REQUEST: '@clientes/CREATE_CLIENTE_REQUEST',
  CREATE_CLIENTE_SUCCESS: '@clientes/CREATE_CLIENTE_SUCCESS',
  CREATE_CLIENTE_FAILURE: '@clientes/CREATE_CLIENTE_FAILURE',

  // EDIT CLIENTE
  EDIT_CLIENTE_REQUEST: '@clientes/EDIT_CLIENTE_REQUEST',
  EDIT_CLIENTE_SUCCESS: '@clientes/EDIT_CLIENTE_SUCCESS',
  EDIT_CLIENTE_FAILURE: '@clientes/EDIT_CLIENTE_FAILURE',

  // DELETE CLIENTE
  DELETE_CLIENTE_REQUEST: '@clientes/DELETE_CLIENTE_REQUEST',
  DELETE_CLIENTE_SUCCESS: '@clientes/DELETE_CLIENTE_SUCCESS',
  DELETE_CLIENTE_FAILURE: '@clientes/DELETE_CLIENTE_FAILURE',

  // UPDATE LOCAL STATE (form, components, cliente)
  UPDATE_CLIENTE: '@clientes/UPDATE_CLIENTE',

  // AGENDAMENTOS CLIENTE
  GET_AGENDAMENTOS_CLIENTE_REQUEST : "@clientes/GET_AGENDAMENTOS_CLIENTE_REQUEST",
GET_AGENDAMENTOS_CLIENTE_SUCCESS : "@clientes/GET_AGENDAMENTOS_CLIENTE_SUCCESS",
GET_AGENDAMENTOS_CLIENTE_FAILURE : "@clientes/GET_AGENDAMENTOS_CLIENTE_FAILURE",

};

export default Types;
